import ReportCover from './ReportCover';
import ExecutiveSummary from './ExecutiveSummary';
import LetterCabinet from './LetterCabinet';
import ContextSection from './ContextSection';
import GlobalPosition from './GlobalPosition';
import AlertsRow from './AlertsRow';

/**
 * Onglet 1 — concentre la page de garde, le résumé exécutif pliable, la
 * lettre du cabinet et les sections I, II, III du brief produit.
 *
 * Ordre stricte (le pharmacien lit du haut vers le bas) :
 *   1. Page de garde (référence édition + identité)
 *   2. Résumé exécutif pliable (Indice + sous-scores + CTA "lire le rapport")
 *   3. Lettre du cabinet (encadré bordeaux, signée)
 *   4. Section I — Contexte officinal
 *   5. Section II — Position globale + radar comparatif + sous-scores
 *   6. Section III — Trois alertes du mois
 */
export default function LetterAndSummaryTab({ report }) {
  return (
    <article className="space-y-20" data-testid="letter-and-summary-tab">
      <ReportCover report={report} />
      <ExecutiveSummary report={report} />
      <LetterCabinet report={report} />
      <ContextSection report={report} />
      <GlobalPosition report={report} />
      <AlertsRow report={report} />
    </article>
  );
}
